<template>
  <div class="relative w-[670px]">
    <!-- 轮播内容（支持手势滑动） -->
    <a
      class="overflow-hidden w-[670px] h-[377px]"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div
        class="flex transition-transform duration-300 ease-in-out"
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      >
        <slot />
      </div>
    </a>

    <!-- 圆点指示器（增加间距） -->
    <div
      v-if="total > 1"
      class="flex justify-center items-center gap-[16px] mt-[20px]"
    >
      <button
        v-for="index in total"
        :key="index"
        class="rounded-full transition-all"
        :class="[
          currentIndex === index - 1
            ? 'w-[12px] h-[12px] bg-[#FF6900]'
            : 'w-[8px] h-[8px] bg-[#D9D9D9]',
        ]"
        @click="goToSlide(index - 1)"
      />
    </div>

    <!-- 左右箭头（可选） -->
    <button
      v-if="total > 1 && showArrows"
      class="absolute left-[10px] top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white rounded-full transition-all w-[40px] h-[40px] flex items-center justify-center"
      @click="prev"
    >
      <span class="text-[20px] text-[#333]">‹</span>
    </button>
    <button
      v-if="total > 1 && showArrows"
      class="absolute right-[10px] top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white rounded-full transition-all w-[40px] h-[40px] flex items-center justify-center"
      @click="next"
    >
      <span class="text-[20px] text-[#333]">›</span>
    </button>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, onUnmounted } from 'vue-demi';
interface Props {
  total: number;
  autoplay?: boolean;
  interval?: number;
  showArrows?: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  total: {
    key: "total",
    required: true,
    type: Number
  },
  autoplay: {
    key: "autoplay",
    required: false,
    type: Boolean,
    default: false
  },
  interval: {
    key: "interval",
    required: false,
    type: Number,
    default: 5000
  },
  showArrows: {
    key: "showArrows",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const currentIndex = ref(0);
  let timer: ReturnType<typeof setInterval> | null = null;

  // 触摸滑动相关变量
  let touchStartX = 0;
  let touchEndX = 0;
  function goToSlide(index: number) {
    currentIndex.value = index;
    resetAutoplay();
  }
  function prev() {
    currentIndex.value = currentIndex.value === 0 ? props.total - 1 : currentIndex.value - 1;
    resetAutoplay();
  }
  function next() {
    currentIndex.value = (currentIndex.value + 1) % props.total;
    resetAutoplay();
  }
  function startAutoplay() {
    if (!props.autoplay || props.total <= 1) return;
    timer = setInterval(() => {
      next();
    }, props.interval);
  }
  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  // 触摸事件处理
  let isSwiping = false; // 标记是否正在滑动

  function handleTouchStart(e: TouchEvent) {
    touchStartX = e.touches[0].clientX;
    touchEndX = touchStartX; // 初始化为相同值，防止点击误触发
    isSwiping = false;
  }
  function handleTouchMove(e: TouchEvent) {
    touchEndX = e.touches[0].clientX;
    isSwiping = true; // 有移动才标记为滑动
  }
  function handleTouchEnd() {
    // 只有真正滑动时才处理，纯点击不触发轮播
    if (!isSwiping) {
      touchStartX = 0;
      touchEndX = 0;
      return;
    }
    const swipeThreshold = 50; // 最小滑动距离
    const diff = touchStartX - touchEndX;
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // 向左滑动，显示下一张
        next();
      } else {
        // 向右滑动，显示上一张
        prev();
      }
    }

    // 重置
    touchStartX = 0;
    touchEndX = 0;
    isSwiping = false;
  }
  onMounted(() => {
    startAutoplay();
  });
  onUnmounted(() => {
    stopAutoplay();
  });
  return {
    currentIndex,
    goToSlide,
    prev,
    next,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd
  };
};
export default __sfc_main;
</script>
